import React from "react";
import { Link } from "react-router-dom";
import { Code2, Maximize2 } from "lucide-react";
import { getUITheme } from "@/lib/uiTheme";
import { DayNightToggle } from "@/components/hud/DayNightToggle";

export function SMLogo({ light = true }) {
  return (
    <div className="flex items-center gap-2 select-none" data-testid="topbar-logo">
      <span
        className="font-display font-bold leading-none tracking-tight text-xl md:text-2xl"
        style={{ color: light ? "#fff" : "#2B2E34" }}
      >
        S<span style={{ color: "#FFCE24" }}>/</span>M
      </span>
      <span
        className="hidden sm:inline font-display uppercase tracking-[0.22em] text-[10px] md:text-xs"
        style={{ color: light ? "rgba(255,255,255,0.66)" : "rgba(43,46,52,0.66)" }}
      >
        Iso World
      </span>
    </div>
  );
}

export function TopBar({ onEmbed, onFullscreen, night = false, onToggleNight, theme }) {
  const t = theme || getUITheme(night);
  return (
    <header className="fixed top-0 left-0 right-0 z-50">
      <div className="relative" style={{ background: t.headerBg, borderBottom: `1px solid ${t.headerBorder}`, transition: "background-color 300ms ease" }}>
        <div className="absolute top-0 left-0 right-0" style={{ height: 3, background: "#FFCE24" }} />
        <div className="mx-auto flex items-center justify-between px-4 md:px-6 h-14 md:h-16 max-w-[1280px]">
          <Link to="/" className="transition-transform hover:-translate-y-[1px]">
            <SMLogo light />
          </Link>
          <div className="hidden lg:block font-body text-sm text-white/55 italic">
            Strategic marketing for home &amp; building brands
          </div>
          <div className="flex items-center gap-2">
            {onToggleNight && (
              <DayNightToggle night={night} onToggle={onToggleNight} theme={t} variant="onDark" />
            )}
            {onFullscreen && (
              <button
                data-testid="topbar-fullscreen-button"
                onClick={onFullscreen}
                title="Enter fullscreen"
                className="inline-flex items-center gap-2 rounded-[10px] px-3 py-2 text-sm font-display font-semibold uppercase tracking-wide text-white hover:bg-white/10 active:scale-[0.98] transition-colors"
              >
                <Maximize2 size={16} /> <span className="hidden md:inline">Fullscreen</span>
              </button>
            )}
            <button
              data-testid="topbar-embed-button"
              onClick={onEmbed}
              className="inline-flex items-center gap-2 rounded-[10px] px-3 py-2 text-sm font-display font-semibold uppercase tracking-wide text-white hover:bg-white/10 active:scale-[0.98] transition-colors"
            >
              <Code2 size={16} /> <span className="hidden sm:inline">Embed</span>
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}

export default TopBar;
